import { c as _c } from "react/compiler-runtime";
import { Divider } from '@common/components';
import { PaymentButton } from '../../_components/PaymentButton';
import { DeliveryFeeTooltip } from './DeliveryFeeTooltip';
import type { DiscountItem } from './DiscountTooltip';
import { DiscountTooltip } from './DiscountTooltip';
interface CartSummarySectionProps {
  productAmount: number;
  deliveryFee: number;
  discountAmount: number;
  finalAmount: number;
  totalCount: number;
  onOrder?: () => void;
  discountItems?: DiscountItem[];
  paymentDisabled?: boolean;
}
export const CartSummarySection = t0 => {
  const $ = _c(37);
  const {
    productAmount,
    deliveryFee,
    discountAmount,
    finalAmount,
    totalCount,
    onOrder,
    discountItems,
    paymentDisabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Divider className="mb-32 mt-40 w-full bg-Gray-300 mobile-tablet:mb-8 mobile-tablet:mt-28" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>선택 상품 금액</span>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== productAmount) {
    t3 = productAmount.toLocaleString();
    $[2] = productAmount;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex items-center justify-between font-500 text-Gray-600 typo-body2 mobile-tablet:typo-body4">{t2}<span>{t3}원</span></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="flex items-center gap-2">총 배송비<DeliveryFeeTooltip /></span>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== deliveryFee) {
    t6 = deliveryFee.toLocaleString();
    $[7] = deliveryFee;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <div className="flex items-center justify-between font-500 text-Gray-600 typo-body2 mobile-tablet:typo-body4">{t5}<span>{t6}원</span></div>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== discountItems) {
    t8 = <span className="flex items-center gap-2 text-Gray-600">예상 할인 금액<DiscountTooltip items={discountItems} /></span>;
    $[11] = discountItems;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = discountAmount > 0 && "-";
  let t10;
  if ($[13] !== discountAmount) {
    t10 = discountAmount.toLocaleString();
    $[13] = discountAmount;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = <span className="text-R-400">{t9}{t10}원</span>;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t8) {
    t12 = <div className="flex items-center justify-between font-500 typo-body2 mobile-tablet:typo-body4">{t8}{t11}</div>;
    $[18] = t11;
    $[19] = t8;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span>예상 결제 금액</span>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== finalAmount) {
    t14 = finalAmount.toLocaleString();
    $[22] = finalAmount;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t14) {
    t15 = <div className="flex items-center justify-between font-700 text-Gray-900 typo-body2 mobile-tablet:font-500 mobile-tablet:typo-body4">{t13}<span>{t14}원</span></div>;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== finalAmount || $[27] !== onOrder || $[28] !== paymentDisabled || $[29] !== totalCount) {
    t16 = <PaymentButton finalAmount={finalAmount} totalCount={totalCount} size="small" className="mt-8 mobile-tablet:mt-10 mobile-tablet:h-40" disabled={paymentDisabled} onClick={onOrder} />;
    $[26] = finalAmount;
    $[27] = onOrder;
    $[28] = paymentDisabled;
    $[29] = totalCount;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t12 || $[32] !== t15 || $[33] !== t16 || $[34] !== t4 || $[35] !== t7) {
    t17 = <div className="flex flex-col gap-12 mobile-tablet:gap-6 mobile-tablet:px-20">{t1}{t4}{t7}{t12}{t15}{t16}</div>;
    $[31] = t12;
    $[32] = t15;
    $[33] = t16;
    $[34] = t4;
    $[35] = t7;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
};